<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<!--open list-->
			<el-tab-pane label="Inventory" name="first">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.name" placeholder="ProduceName or UPC" clearable @keyup.enter.native="getInventory">
								<el-button slot="append" icon="el-icon-search" @click="getInventory"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="exportExcel('/excel/exportNurseInventory','Inventory.xls')">Export</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="success" @click="goToMixedPackageClaim">Mixed Package</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="products" highlight-current-row v-loading="listLoading"  style="width: 100%;">
					<el-table-column label="#">
						<template slot-scope="scope">
							{{scope.row.productNo}}
						</template>
					</el-table-column>
					<el-table-column prop="productName" label="ProductName" >
						<template slot-scope="scope">
							{{scope.row.productName}} {{scope.row.createDate?"("+scope.row.createDate+")":""}}
							<p class="note">{{scope.row.upc}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="qty" label="Qty" >
					</el-table-column>
					<el-table-column prop="left" label="Left" >
					</el-table-column>
					<el-table-column prop="warehouse" label="Warehouse" >
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope">
							<el-button size="small" @click="showReportInventory(scope.row)">Report</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize"
								   :total="total" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
			<el-tab-pane label="Zero Storage" name="second" v-if="role==3">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.zeroName" placeholder="ProduceName or UPC" clearable @keyup.enter.native="getZeroInventory">
								<el-button slot="append" icon="el-icon-search" @click="getZeroInventory"></el-button>
							</el-input>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="zeroInventory" highlight-current-row v-loading="listLoading"  style="width: 100%;">
					<el-table-column label="#">
						<template slot-scope="scope">
							{{scope.row.productNo}}
						</template>
					</el-table-column>
					<el-table-column prop="productName" label="ProductName" >
						<template slot-scope="scope">
							{{scope.row.productName}} {{scope.row.createDate?"("+scope.row.createDate+")":""}}
							<p class="note">{{scope.row.upc}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="qty" label="Qty" >
					</el-table-column>
					<el-table-column prop="left" label="Left" >
					</el-table-column>
					<el-table-column prop="warehouse" label="Warehouse" >
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleZeroChange" :page-size="pageSize"
								   :total="zeroInventroyTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>

			<el-tab-pane label="Products" name="third" v-if="role==3">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.doctorProductName" placeholder="ProduceName or UPC" clearable @keyup.enter.native="getDoctorProductList">
								<el-button slot="append" icon="el-icon-search" @click="getDoctorProductList"></el-button>
							</el-input>
						</el-form-item>
                        <el-form-item class="pull-right">
                            <el-button type="primary" @click="addFormVisible=true">Add Product</el-button>
                        </el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="doctorProductList" highlight-current-row v-loading="listLoading"  style="width: 100%;">
					<el-table-column label="#">
						<template slot-scope="scope">
							{{scope.row.productNo}}
						</template>
					</el-table-column>
					<el-table-column prop="productName" label="ProductName" >
						<template slot-scope="scope">
							{{scope.row.productName}} {{scope.row.createDate?"("+scope.row.createDate+")":""}}
							<p class="note">{{scope.row.upc}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="size" label="Category" >
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope">
							<el-button size="small" @click="handleEditProduct(scope.row)">Edit Product</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleProductChange" :page-size="pageSize"
								   :total="total" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
			
			<el-tab-pane label="Product Pool" name="fourth" v-if="role==3">
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.productTemplateCondition" placeholder="ProduceName or UPC" clearable @keyup.enter.native="getProductTemplateList" style="width: 400px">
								<el-button slot="append" icon="el-icon-search" @click="getProductTemplateList"></el-button>
							</el-input>
						</el-form-item>
						<el-form-item class="pull-right">
							<el-button type="primary" @click="productTemplateAddFormVisible=true">Add Product</el-button>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="productTemplateList" highlight-current-row v-loading="listLoading"  style="width: 100%;">
					<el-table-column label="#">
						<template slot-scope="scope">
							{{scope.row.productNo}}
						</template>
					</el-table-column>
					<el-table-column prop="productName" label="ProductName" >
						<template slot-scope="scope">
							{{scope.row.productName}} {{scope.row.createDate?"("+scope.row.createDate+")":""}}
							<p class="note">{{scope.row.upc}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="size" label="Category" >
					</el-table-column>
					<el-table-column prop="storageFreeDuration" label="Storage Free Duration (Month)" >
						<template slot-scope="scope">
							{{ scope.row.storageFreeDuration != null ? scope.row.storageFreeDuration : "Not Set"}}
						</template>
					</el-table-column>
					<el-table-column prop="status" label="Status" >
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status == 0" type="warning">Not Distribute</el-tag>
							<el-tag v-else-if="scope.row.status == 1" type="success">Distributed</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope">
							<el-button size="small" type="warning" @click="handleEditProductTemplate(scope.row)">Edit Product Template</el-button>
							<el-button size="small" type="danger" @click="showDistributeSelectDoctorWin(scope.row)">Distribute</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleProductTemplateChange" :page-size="pageSize" 
								   :total="productTemplateTotal" style="float:right;">
					</el-pagination>
				</el-col>
			</el-tab-pane>
		</el-tabs>
		<!--open list-->

		<!--新增界面-->
		<el-dialog title="Report Missing Items" width="80%" :visible.sync="reportFormVisible" :close-on-click-modal="false">
			<el-form :model="report" label-width="220px" :rules="formRules" ref="report">
				<el-form-item label="Product Name" prop="Name">
					<el-input v-model="report.product" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="Missing Item" prop="id">
					<el-select v-model="report.id" style="width:100%" @change="changeItem()" clearable filterable>
						<el-option v-for="(item,index) in report.items" :key="index" :value="item.id" :label="item.displayName"></el-option>
					</el-select>
				</el-form-item>
				<!--<el-form-item label="Company" prop="company">
					<el-input v-model="report.company" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>-->
				<!--<el-form-item label="Warehouse" prop="warehouse">
					<el-input v-model="report.warehouse" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>-->
				<!--<el-form-item label="Price" prop="price">
					<el-input v-model="report.price" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>-->
				<el-form-item label="Quantity" prop="quantity">
					<el-input-number v-model="report.quantity" :min="0" auto-complete="off"></el-input-number>
				</el-form-item>
				<el-form-item label="Note" prop="note">
					<el-input v-model="report.note" type="textarea" rows="5" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="reportFormVisible = false">Close</el-button>
				<el-button type="primary" @click.native="handleReportInventory" :loading="loading">Submit</el-button>
			</div>
		</el-dialog>

        <!--新增界面-->
        <el-dialog title="Add Product" width="80%" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addProduct" label-width="220px" :rules="productFormRules" ref="addProduct">
                <el-form-item label="Name" prop="product">
                    <el-input v-model="addProduct.product" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Category" prop="size">
                    <el-select v-model="addProduct.size" auto-complete="off">
                        <el-option v-for="(size,index) in sizeList" :key="index" :value="size" :label="size"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="Storage Free Duration (Month)" prop="storageFreeDuration">
					<el-input-number v-model="addProduct.storageFreeDuration" ></el-input-number>
				</el-form-item>
                <el-form-item label="Condition" prop="condition">
                    <el-select v-model="addProduct.condition" auto-complete="off">
                        <el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN" prop="asin">
                    <el-input v-model="addProduct.asin"></el-input>
                </el-form-item>
                <el-form-item label="UPC" prop="upc">
                    <el-input v-model="addProduct.upc"></el-input>
                </el-form-item>
                <el-form-item label="Weight" prop="weight">
                    <el-input v-model="addProduct.weight"></el-input>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <el-input v-model="addProduct.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleAddProduct" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Edit Product" width="80%" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editProduct" label-width="220px" :rules="productFormRules" ref="editProduct">
                <el-form-item label="Name" prop="Name">
                    <el-input v-model="editProduct.productName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
				<el-form-item label="Storage Free Duration (Month)" prop="storageFreeDuration">
					<el-input-number v-model="editProduct.storageFreeDuration" ></el-input-number>
				</el-form-item>
                <el-form-item label="Category" prop="size">
                    <el-select v-model="editProduct.size" auto-complete="off">
                        <el-option v-for="(size,index) in sizeList" :key="index" :value="size" :label="size"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Condition" prop="condition">
                    <el-select v-model="editProduct.condition" auto-complete="off">
                        <el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN">
                    <el-input v-model="editProduct.asin"></el-input>
                </el-form-item>
                <el-form-item label="UPC">
                    <el-input v-model="editProduct.upc"></el-input>
                </el-form-item>
                <el-form-item label="Weight">
                    <el-input v-model="editProduct.weight"></el-input>
                </el-form-item>
                <el-form-item label="Note">
                    <el-input v-model="editProduct.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
		
        <!--新增产品模板界面-->
        <el-dialog title="Add Product Template" width="80%" :visible.sync="productTemplateAddFormVisible" :close-on-click-modal="false">
            <el-form :model="addProductTemplate" label-width="220px" :rules="productFormRules" ref="addProductTemplate">
                <el-form-item label="Name" prop="product">
                    <el-input v-model="addProductTemplate.product" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Category" prop="size">
                    <el-select v-model="addProductTemplate.size" auto-complete="off">
                        <el-option v-for="(size,index) in sizeList" :key="index" :value="size" :label="size"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="Storage Free Duration (Month)" prop="storageFreeDuration">
					<el-input-number v-model="addProductTemplate.storageFreeDuration" ></el-input-number>
				</el-form-item>
                <el-form-item label="Condition" prop="condition">
                    <el-select v-model="addProductTemplate.condition" auto-complete="off">
                        <el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN" prop="asin">
                    <el-input v-model="addProductTemplate.asin"></el-input>
                </el-form-item>
                <el-form-item label="UPC" prop="upc">
                    <el-input v-model="addProductTemplate.upc"></el-input>
                </el-form-item>
                <el-form-item label="Weight" prop="weight">
                    <el-input v-model="addProductTemplate.weight"></el-input>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <el-input v-model="addProductTemplate.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="productTemplateAddFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleAddProductTemplate" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Edit Product Template" width="80%" :visible.sync="productTemplateEditFormVisible" :close-on-click-modal="false">
            <el-form :model="editProductTemplate" label-width="220px" :rules="productFormRules" ref="editProductTemplate">
                <el-form-item label="Name" prop="Name">
                    <el-input v-model="editProductTemplate.productName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
				<el-form-item label="Storage Free Duration (Month)" prop="storageFreeDuration">
					<el-input-number v-model="editProductTemplate.storageFreeDuration" ></el-input-number>
				</el-form-item>
                <el-form-item label="Category" prop="size">
                    <el-select v-model="editProductTemplate.size" auto-complete="off">
                        <el-option v-for="(size,index) in sizeList" :key="index" :value="size" :label="size"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Condition" prop="condition">
                    <el-select v-model="editProductTemplate.condition" auto-complete="off">
                        <el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN">
                    <el-input v-model="editProductTemplate.asin"></el-input>
                </el-form-item>
                <el-form-item label="UPC">
                    <el-input v-model="editProductTemplate.upc" :disabled="editProductTemplate.status == 1 ? true : false"></el-input>
                </el-form-item>
                <el-form-item label="Weight">
                    <el-input v-model="editProductTemplate.weight"></el-input>
                </el-form-item>
                <el-form-item label="Note">
                    <el-input v-model="editProductTemplate.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="productTemplateEditFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editSubmitTemplate" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
		
        <!--仓库端产品下发界面-->
        <el-dialog title="Select which users to send under" width="80%" :visible.sync="selectDoctorsVisible" :close-on-click-modal="false">
			<div>
				<el-tag effect="dark" v-for="(userName,index) in selectedDoctorNames" :key="index">{{ userName }}</el-tag>
			</div>
			
			<el-select v-model="distributeSelectedDoctors" multiple clearable style="width: 350px;">
				<el-option v-for="(user,index) in doctorList" :key="index" :label="user.userName"
							:value="user.userNo"></el-option>
			</el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="selectDoctorsVisible = false;distributeSelectedDoctors = [];">Close</el-button>
                <el-button type="primary" @click.native="distributeProductTempate" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>
	</section>
</template>


<script>
	import util from '../../common/js/util'
    import {
        getUserInventory,
        reportInventory,
        getInventoryByProduct,
        getZeroInventory,
        getDoctorProductList, addProduct, getSizeList, getProductById,
		addProductTemplate, getProductTemplateById, deleteProductTemplate, getProductTemplateListByCondition, distributeProductTempate, getDistributedDoctorName
    } from '../../api/inventoryService';
    import {conditions, defaultPageSize} from "../../globalVar";
	import {postExportExcel} from "../../api/exportService";
    import {getNurseDoctor} from "../../api/memberService";

	export default {
		created(){
			this.$on('changeDoctor',(value) => {
				setTimeout(()=>{
					this.getInventory();
				},300);
			});
		},
		data() {
			return {
				filters: {
					name: '',
					zeroName:"",
					doctorProductName:"",
					productTemplateCondition: "",
				},

                conditions:conditions,

                doctorProductList:[],
				doctorProductTotal:0,
				doctorProductPage:1,

				zeroInventory:[],
				zeroInventroyTotal:0,
				zeroInventoryPage:1,

                products: [],
				total: 0,
				page: 1,

				pageSize:defaultPageSize,
                activeName:"first",

				listLoading: false,
				loading:false,
				sels: [],//列表选中列

                sizeList:[],

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{required: true, message: '请输入姓名', trigger: 'blur'}
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				reportFormVisible: false,//新增界面是否显示
                addFormVisible: false,//新增界面是否显示
                editFormVisible: false,//编辑界面是否显示
				formRules: {
					id: [
						{required: true, message: 'Missing Item is required.', trigger: 'blur'}
					],
					quantity: [
						{required: true, message: 'Quantity is required.', trigger: 'blur'},
						{validator: this.checkQuantity,  trigger: 'blur'}
					]
				},
				report: {
					id:"",
					product: '',
					company:"",
					price: "",
					note: "",
					warehouse:"",
					warehouseNo:"",
					quantity:0,
					total:0,
					items:[]
				},
				role:"",

                editProduct:{
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: "",
                    size:"",
                    storageFreeDuration: undefined
                },
                //新增界面数据
                addProduct: {
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: "",
                    size:"",
                    storageFreeDuration: undefined
                },

				// 产品池
				productTemplatePage: 1,
                productTemplateList:[],
				productTemplateTotal:0,
                productTemplateAddFormVisible: false,//新增界面是否显示
                productTemplateEditFormVisible: false,//编辑界面是否显示
                editProductTemplate:{
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: "",
                    size:"",
                    storageFreeDuration: undefined,
                },
                //新增界面数据
                addProductTemplate: {
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: "",
                    size:"",
                    storageFreeDuration: undefined,
                },

				// 下发产品给神医
				distributeSelectedDoctors: [],
				selectedProductNo: null,
				selectDoctorsVisible: false,
				doctorList:[],
				selectedDoctorNames:[],

                productFormRules: {
                    product: [
                        {required: true, message: 'Product Name is required.', trigger: 'blur'}
                    ],
                    upc: [
                        {required: true, message: 'UPC is required.', trigger: 'blur'}
                    ],
                    size: [
                        {required: true, message: 'Size is required.', trigger: 'blur'}
                    ]
                },

			}
		},
		methods: {
			changeItem(){
				let reportId =this.report.id;
				let selectItem = this.report.items.find((item)=>{
					return item.id==reportId;
				});
				this.report.total = selectItem.total;
			},
			exportExcel(url,fileName,type){
				let param = {
					url:url,
					fileName:fileName,
					doctorNo:window.sessionStorage.getItem("currentCompany")
				}
				postExportExcel(param).then(function(){

				})
			},
			checkQuantity(rule, value, callback) {
				if (!value>0) {
					return callback(new Error('Report quantity must more than 1.'));
				}else if(value>this.report.total){
					return callback(new Error("Report quantity can't more than Total."));
				}else{
					callback();
				}
			},
			handleReportInventory(){
				this.$refs.report.validate((valid)=>{
					if(valid){
						let param = {
							itemId:this.report.id,
							warehouseNo:this.report.warehouseNo,
							note:this.report.note,
							quantity:this.report.quantity,
							doctorNo:window.sessionStorage.getItem("currentCompany")
						};
						this.loading = true;
						reportInventory(param).then((data)=>{
							this.loading = false;
							if(data.status===200){
								this.$message.success(data.message);
								this.reportFormVisible = false;
								this.$refs.report.resetFields();
								this.getInventory();
							}else{
								this.$message.error(data.message);
							}
						})
					}
				})
			},
			showReportInventory(row){
				let param = {
					doctorNo:window.sessionStorage.getItem("currentCompany"),
					productNo:row.productNo,
					warehouseNo:row.warehouseNo
				}
				getInventoryByProduct(param).then((data)=>{
					// this.report.inboundNo= row.inboundNo;
					// this.report.cwId = row.cwId;
					// this.report.company = row.company;
					// this.report.price = row.price;
					this.report.items = data.result;
					this.report.product = row.productName;
					this.report.warehouse = row.warehouse;
					this.report.warehouseNo = row.warehouseNo;
					// this.report.total= row.qty;
					this.reportFormVisible = true;
				})
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getInventory();
			},
            handleZeroChange(val){
			    this.zeroInventoryPage = val;
			    this.getZeroInventory();
			},
            handleProductChange(val){
                this.doctorProductPage = val;
                this.getDoctorProductList();
            },
            handleProductTemplateChange(val){
                this.productTemplatePage = val;
                this.getProductTemplateList();
            },
            getSizeList(){
                getSizeList({}).then((data)=>{
                    if (data.status === 200) {
                        this.sizeList = data.result;
                    }
                })
            },
			getInventory() {
                let para = {
                    current: this.page,
                    size:this.pageSize,
                    condition: this.filters.name,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                };
                this.listLoading = true;
                getUserInventory(para).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.products = res.result.records;
                        this.total = res.result.total;
                    }
                });
            },
            getZeroInventory(){
                let para = {
                    current: this.zeroInventoryPage,
                    size:this.pageSize,
                    condition: this.filters.zeroName,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                };
                this.listLoading = true;
                getZeroInventory(para).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.zeroInventory = res.result.records;
                        this.zeroInventroyTotal = res.result.total;
                    }
                });
			},
            getDoctorProductList() {
                let para = {
                    current: this.doctorProductPage,
                    size:this.pageSize,
                    condition: this.filters.doctorProductName,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
                };
                this.listLoading = true;
                getDoctorProductList(para).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.doctorProductList = res.result.records;
                        this.doctorProductTotal = res.result.total;
                    } else {
						this.$message.error(res.message);
					}
                });
            },
            getProductTemplateList() {
                let para = {
                    current: this.productTemplatePage,
                    size: this.pageSize,
                    upc: this.filters.productTemplateCondition,
                };
                this.listLoading = true;
                getProductTemplateListByCondition(para).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.productTemplateList = res.result.records;
                        this.productTemplateTotal = res.result.total;
                    } else {
						this.$message.error(res.message);
					}
                });
            },
            //编辑
            editSubmit: function () {
                this.$refs.editProduct.validate((valid) => {
                    if (valid) {
                        let param = {
                            productNo:this.editProduct.productNo,
                            // productName:this.editProduct.productName,
                            condition:this.editProduct.condition,
                            asin:this.editProduct.asin,
                            upc:this.editProduct.upc,
                            weight:this.editProduct.weight,
                            note:this.editProduct.note,
                            size:this.editProduct.size,
                            storageFreeDuration: this.editProduct.storageFreeDuration,
                            doctorNo:window.sessionStorage.getItem("currentCompany")

                        };
                        this.loading = true;
                        addProduct(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.editFormVisible = false;
                                this.$refs.editProduct.resetFields();
                                this.getDoctorProductList();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            },
            //编辑
            editSubmitTemplate: function () {
                this.$refs.editProductTemplate.validate((valid) => {
                    if (valid) {
                        let param = {
                            productNo:this.editProductTemplate.productNo,
                            condition:this.editProductTemplate.condition,
                            asin:this.editProductTemplate.asin,
                            upc:this.editProductTemplate.upc,
                            weight:this.editProductTemplate.weight,
                            note:this.editProductTemplate.note,
                            size:this.editProductTemplate.size,
                            storageFreeDuration: this.editProductTemplate.storageFreeDuration,

                        };
                        this.loading = true;
                        addProductTemplate(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.productTemplateEditFormVisible = false;
                                this.$refs.editProductTemplate.resetFields();
                                this.getProductTemplateList();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            },
            //新增
            handleAddProduct: function () {
                this.$refs.addProduct.validate((valid) => {
                    if (valid) {
                        let param = {
                            productName:this.addProduct.product,
                            condition:this.addProduct.condition,
                            asin:this.addProduct.asin,
                            upc:this.addProduct.upc,
                            weight:this.addProduct.weight,
                            note:this.addProduct.note,
                            size:this.addProduct.size,
                            storageFreeDuration: this.addProduct.storageFreeDuration,
                            doctorNo:window.sessionStorage.getItem("currentCompany")
                        };
                        this.loading = true;
                        addProduct(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.addFormVisible = false;
                                this.$refs.addProduct.resetFields();
                                this.getDoctorProductList();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            },
            //新增
            handleAddProductTemplate: function () {
                this.$refs.addProductTemplate.validate((valid) => {
                    if (valid) {
                        let param = {
                            productName:this.addProductTemplate.product,
                            condition:this.addProductTemplate.condition,
                            asin:this.addProductTemplate.asin,
                            upc:this.addProductTemplate.upc,
                            weight:this.addProductTemplate.weight,
                            note:this.addProductTemplate.note,
                            size:this.addProductTemplate.size,
                            storageFreeDuration: this.addProductTemplate.storageFreeDuration,
                        };
                        this.loading = true;
                        addProductTemplate(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.productTemplateAddFormVisible = false;
                                this.$refs.addProductTemplate.resetFields();
                                this.getProductTemplateList();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            },
            handleEditProduct(row){
			    let para ={
			        productNo:row.productNo,
                    doctorNo:window.sessionStorage.getItem("currentCompany")
				}
                getProductById(para).then((data)=>{
                    this.editProduct = data.result;
                    this.editFormVisible = true;
                    if (this.editProduct.storageFreeDuration == null) {
                    	this.editProduct.storageFreeDuration = undefined;
					}
				})
            },
            handleEditProductTemplate(row){
			    let para ={
			        productNo:row.productNo,
				}
                getProductTemplateById(para).then((data)=>{
                    this.editProductTemplate = data.result;
                    this.productTemplateEditFormVisible = true;
                    if (this.editProductTemplate.storageFreeDuration == null) {
                    	this.editProductTemplate.storageFreeDuration = undefined;
					}
				})
            },
			showDistributeSelectDoctorWin(row) {
				this.selectedProductNo = row.productNo;
				let para ={
			        productNo:row.productNo,
				}
                getDistributedDoctorName(para).then((data)=>{
                    if(data.status===200){
						this.selectedDoctorNames = data.result;
						getNurseDoctor().then((res)=>{
							this.doctorList = res.result;
							this.selectDoctorsVisible = true;
						})
					}else {
						this.$message({
							message:data.message,
							type:"error"
						})
					}
				})
			},
			distributeProductTempate() {
			    let para ={
			        productNo:this.selectedProductNo,
					doctorNos: this.distributeSelectedDoctors,
				}

                this.loading = true;
                distributeProductTempate(para).then((data)=>{
					if(data.status===200){
                        if (data.result.length == 0) {
                            this.$message({
                                message:data.message,
                                type:"success"
                            });
                            this.getProductTemplateList();
                            this.distributeSelectedDoctors = [];
						    this.selectDoctorsVisible = false;
                        } else {
                            let para ={
                                productNo:this.selectedProductNo,
                            }
                            getDistributedDoctorName(para).then((data)=>{
                                if(data.status===200){
                                    this.selectedDoctorNames = data.result;
                                    getNurseDoctor().then((res)=>{
                                        this.doctorList = res.result;
                                        this.selectDoctorsVisible = true;
                                    })
                                }else {
                                    this.$message({
                                        message:data.message,
                                        type:"error"
                                    })
                                }
                            })
                            this.$message({
                                message: "Distribute failed User:" + data.result,
                                type:"error"
                            })
                        }
					}else {
						this.$message({
							message: data.message,
							type:"error"
						})
					}
                    this.loading = false;
				})
			},
			goToMixedPackageClaim() {
				// 根据用户角色跳转到不同页面
				// roleId: 3-仓库管理员, 2-护士, 1-神医
				if (this.role === '3') {
					// 仓库管理员跳转到混寄包裹管理页面（新版）
					this.$router.push('/mixedPackageList');
				} else {
					// 神医/护士跳转到混寄认领页面
					this.$router.push('/mixedPackageClaim');
				}
			},
		},
		mounted() {
			this.getInventory();
			this.getZeroInventory();
			this.getDoctorProductList();
			this.role = JSON.parse(window.sessionStorage.getItem("user")).roleId;
			if (this.role == '3') {
				this.getProductTemplateList();
				this.getSizeList();
			}
		}
	}

</script>


// WEBPACK FOOTER //
// inventory.vue?648627d5